import React, { useState, useEffect } from 'react'
import zellerWeek from './useZellerWeek'
import { Popover } from 'antd-mobile'
import Calendar2 from '../../Icons/Calendar2'
import Left from '../../Icons/Left'
import Right from '../../Icons/Right'
import { MyBadgeDot } from '../MyBadge'
import './MyCalendarStyle.css'
import intl from 'react-intl-universal'
export default function MyCalendar2 (props) {
  const week = { // 星期几的字符串数组(在日历组件上方，显示被选中的日期是星期几)
    0: intl.get('Sunday'),
    1: intl.get('Monday'),
    2: intl.get('Tuesday'),
    3: intl.get('Wednesday'),
    4: intl.get('Thursday'),
    5: intl.get('Friday'),
    6: intl.get('Saturday')
  }

  const weekShort = {
    1: intl.get('SundayShort'),
    2: intl.get('MondayShort'),
    3: intl.get('TuesdayShort'),
    4: intl.get('WednesdayShort'),
    5: intl.get('ThursdayShort'),
    6: intl.get('FridayShort'),
    7: intl.get('SaturdayShort')
  }
  const [today, setToday] = useState(new Date()) // 获取今天的日期对象
  const [year, setYear] = useState(today.getFullYear()) // 年份 选中的
  const [month, setMonth] = useState(today.getMonth() + 1) // 月份 选中的
  const [date, setDate] = useState(props.selectedDate || today.getDate()) // 日期 选中的
  const [yearText, setYearText] = useState(today.getFullYear()) // 年份 显示的
  const [monthText, setMonthText] = useState(today.getMonth() + 1) // 月份 显示的
  const [dateText, setDateText] = useState(props.selectedDate || today.getDate()) // 日期 显示的
  const [day, setDay] = useState(week[zellerWeek(year, month, date)]) // 星期几的字符串
  const [FebruaryDays, setFebruaryDays] = useState(28) // 设置二月默认天数为28天
  const monthsArray = { // 月份的字符串
    1: '01',
    2: '02',
    3: '03',
    4: '04',
    5: '05',
    6: '06',
    7: '07',
    8: '08',
    9: '09',
    10: '10',
    11: '11',
    12: '12'
  }
  const [monthDaysArray, setMonthDaysArray] = useState({ // 每个月有多少天
    1: 31,
    2: FebruaryDays,
    3: 31,
    4: 30,
    5: 31,
    6: 30,
    7: 31,
    8: 31,
    9: 30,
    10: 31,
    11: 30,
    12: 31
  })
  const [liStyles, setliStyles] = useState([]) // 日历里每天的样式
  const dayStyle = { flexGrow: 0, flexShrink: 0, width: '25px', height: '25px', lineHeight: '25px', fontSize: '0.8rem', padding: 0, marginLeft: '5px', marginRight: '5px', textAlign: 'center', color: '#9B9B9B', display: 'inline-block', fontWeight: 'bolder' } // 日历组件上方展示星期的样式
  const blankStyle = { flexGrow: 0, flexShrink: 0, width: '25px', fontSize: '1rem', padding: 0, marginLeft: '5px', marginRight: '5px', textAlign: 'center', borderRadius: '50%', color: '#9B9B9B', display: 'inline-block', fontWeight: 'bolder' } // 日历组件上方展示星期的样式
  const unselectedDateStyle = { flexGrow: 0, flexShrink: 0, width: '25px', height: '25px', lineHeight: '25px', fontSize: '1rem', padding: 0, marginLeft: '5px', marginRight: '5px', textAlign: 'center', color: '#9B9B9B', display: 'inline-block' } // 未被选中的日期的样式
  const selectedDateStyle = { flexGrow: 0, flexShrink: 0, width: '25px', height: '25px', lineHeight: '25px', fontSize: '1rem', textAlign: 'center', padding: 0, marginLeft: '5px', marginRight: '5px', borderRadius: '50%', backgroundColor: '#F5004D', color: 'white', display: 'inline-block' } // 被选中的日期的样式
  const disabledDateStyle = { flexGrow: 0, flexShrink: 0, width: '25px', height: '25px', lineHeight: '25px', fontSize: '1rem', textAlign: 'center', padding: 0, marginLeft: '5px', marginRight: '5px', borderBottomLeftRadius: '20%', borderBottomRightRadius: '20%', color: '#eeeeee', display: 'inline-block' } // 不可选择的日期的样式
  const selectedOrder = props.selectedDates || [] // 左上角有粉红色圆点的日期数组,格式为['2019-08-23', '2019-08-24']
  const enabledDates = props.enabledDates || [] // 可以选择的日期
  const [dateArray, setDateArray] = useState([]) // 用来存放每个月每一天的html标签的数组
  const [height, setHeight] = useState(0)
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    if (props.defaultDate && props.defaultDate.replace(/[/]/g, '') !== '') {
      setToday(new Date(props.defaultDate))
    }
  }, [props.defaultDate])

  useEffect(() => {
    setMonth(today.getMonth() + 1)
    setYear(today.getFullYear())
    setDate(today.getDate())
    setMonthText(today.getMonth() + 1)
    setYearText(today.getFullYear())
    setDateText(today.getDate())
  }, [today])
  useEffect(() => { // 闰年2月29天
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      setFebruaryDays(29)
    } else {
      setFebruaryDays(28)
    }
  }, [year])

  useEffect(() => {
    if (month === 2 && (!(year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)) {
      setHeight(40 * Math.ceil((monthDaysArray[month] + zellerWeek(year, month, 1)) / 7) + 15)
    } else {
      setHeight(40 * Math.ceil((monthDaysArray[month] + zellerWeek(year, month, 1)) / 7) + 10)
    }
  }, [month])

  useEffect(() => {
    setMonthDaysArray({
      1: 31,
      2: FebruaryDays,
      3: 31,
      4: 30,
      5: 31,
      6: 30,
      7: 31,
      8: 31,
      9: 30,
      10: 31,
      11: 30,
      12: 31
    })
  }, [FebruaryDays])

  /**
   * 当用户选择日期且改变日期栏样式数组之后，将样式设置到组件中
   */
  useEffect(() => {
    const dateArrayTemp = []
    const header = []
    for (let i = 1; i < 8; i++) {
      const day = <div
        key={`day${i}`}
        style={dayStyle}
      >
        {weekShort[i]}
      </div>
      header.push(day)
    }
    dateArrayTemp.push(...header)
    for (let i = 0; i < zellerWeek(year, month, 1); i++) {
      const blankDiv = <div key={`blank${i}`} style={blankStyle} />
      dateArrayTemp.push(blankDiv)
    }
    for (let i = 1; i <= monthDaysArray[month]; i++) {
      const obj = <div
        onClick={() => handleOnClick(i)}
        key={i}
        style={liStyles[i]}
      >
        {
          selectedOrder.includes(`${year}-${month < 10 ? `0${month}` : month}-${i < 10 ? `0${i}` : i}`) ? <MyBadgeDot key={`${year}-${month < 10 ? `0${month}` : month}-${i < 10 ? `0${i}` : i}`} height={5} width={5} /> : null
        }
        {i}
      </div>
      dateArrayTemp.push(obj)
      if ((i + zellerWeek(year, month, 1)) % 7 === 0) {
        dateArrayTemp.push(<br key={`br1-${i}`} />)
        dateArrayTemp.push(<br key={`br2-${i}`} />)
      }
    }
    setDateArray(dateArrayTemp)
  }, [liStyles, props.selectedDates, day])

  /**
   * 当年月日变化时，样式也变化
   */
  useEffect(() => {
    setDay(week[zellerWeek(year, month, date)])
    const temp = liStyles.slice(0)
    for (let i = 1; i <= monthDaysArray[month]; i++) {
      temp[i] = unselectedDateStyle
      if (!enabledDates.includes(`${year}-${month < 10 ? `0${month}` : month}-${i < 10 ? `0${i}` : i}`)) {
        temp[i] = disabledDateStyle
      }
    }
    if (monthDaysArray[month] >= date && month === monthText && year === yearText) {
      temp[date] = selectedDateStyle
    }
    setliStyles(temp)
  }, [year, month, date, enabledDates.join(',')])

  /**
   * 当用户点击日期数字时触发
   */
  function handleOnClick (date) {
    // year-month-date: 用户点击的年月日
    // yearText-monthText-dateText: 默认显示的年月日
    if (enabledDates.includes(`${year}-${month < 10 ? `0${month}` : month}-${date < 10 ? `0${date}` : date}`)) {
      if ((date !== dateText) || (month !== monthText) || (year !== yearText)) {
        props.setMealType('')
        props.getDate(year, month, date)
        setDate(date)
        setDateText(date)
        setMonth(month)
        setMonthText(month)
        setYear(year)
        setYearText(year)
        setVisible(false)
      }
    }
  }

  /**
   * 年份变化的时候需要改变
   * 判断是否是闰年
   */
  useEffect(() => {
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      setFebruaryDays(29)
    }
  }, [year])

  /**
   * 月份减触发
   */
  function handleOnMonthDelete () {
    if (month - 1 < 1) {
      setMonth(12)
      setYear(year - 1)
    } else {
      setMonth(month - 1)
    }
  }

  /**
   * 月份加触发
   */
  function handleOnMonthAdd () {
    if (month + 1 > 12) {
      setMonth(1)
      setYear(year + 1)
    } else {
      setMonth(month + 1)
    }
  }

  React.useEffect(() => {
    document.addEventListener('touchstart', (e) => {
      if (document.getElementsByClassName('am-popover-mask')[document.getElementsByClassName('am-popover-mask').length - 1].contains(e.target)) {
        e.preventDefault()
        e.stopPropagation()
      }
    }, {
      passive: false
    })
  }, [])

  return (
    <div>
      <Popover
        overlayClassName={'myCalendar'}
        placement={'bottomRight'}
        mask
        visible={visible}
        onVisibleChange={(visible) => setVisible(visible)}
        align={{
          overflow: { adjustY: 0, adjustX: 0 },
          offset: [-10, 0]
        }}
        overlay={
          <div className='fixed r0 bgf' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', marginTop: '10px', marginBottom: '10px' }}>
              <Left onClick={() => handleOnMonthDelete()} width={10} height={10} />
              <div style={{ color: '#F5004D', fontSize: '14px', fontFamily: '微软雅黑', fontWeight: 'bold' }}>{day}</div>
              <div style={{ color: '#F5004D', fontSize: '14px', fontFamily: '微软雅黑', fontWeight: 'bold' }}>{`${year}-${monthsArray[month]}`}</div>
              <Right onClick={() => handleOnMonthAdd()} width={10} height={10} />
            </div>
            <div style={{ width: '100%', height: '4px', backgroundColor: '#F5004D', marginBottom: '0px' }} />
            <div style={{ overflowY: 'auto', width: '245px', marginTop: '10px', marginLeft: '10px', marginRight: '10px' }}>
              {dateArray.slice(0, 7)}
            </div>
            <div style={{ overflowY: 'auto', height: height, width: '245px', marginTop: '10px', marginBottom: '20px', marginLeft: '10px', marginRight: '10px' }}>
              {dateArray.slice(7)}
            </div>
          </div>
        }
      >
        {/* <div className='lt1-5' style={{ float: 'right', backgroundColor: '#c6347d', width: '120px', height: 24, textAlign: 'center', paddingTop: 0, paddingBottom: 0, display: 'flex', flexDirection: 'row', alignItems: 'center', borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px', color: 'white', fontSize: '14px', fontFamily: 'Arial' }}>
          <div style={{ position: 'absoulte', top: 0, left: 0, height: 24, width: 24, backgroundColor: '#F74F83', borderTopLeftRadius: '50%', borderBottomLeftRadius: '50%', borderBottomRightRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexGrow: 0, flexShrink: 0, marginRight: 5 }}>
            <Clock height={16} width={16} />
          </div>
          {intl.get('SelectDate')}
          {`${yearText}-${monthsArray[monthText]}-${dateText < 10 ? `0${dateText}` : dateText}`}
        </div> */}
        <div style={{ height: '30px', display: 'flex', flexDirection: 'row' }}>
          <div className={'leftContent'} style={{ display: 'flex', flexDirection: 'column', flex: 3, justifyContent: 'cneter', alignItems: 'center', height: '30px' }}>
            <div className={'left1 lt1-5'} style={{ fontSize: '0.8rem', width: '100%', padding: 0, height: '15px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center' }}>
              {intl.get('SelectDate')}
            </div>
            <div className={'left2 lt1'} style={{ fontSize: '1rem', width: '100%', padding: 0, height: '15px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center' }}>
              {`${yearText}-${monthsArray[monthText]}-${dateText < 10 ? `0${dateText}` : dateText}`}
            </div>
          </div>
          <div className={'rightContent'} style={{ flex: 1, height: '30px', display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
            <Calendar2 height={'30px'} width={'30px'} />
          </div>
        </div>
      </Popover>
    </div>
  )
}
